document.addEventListener('DOMContentLoaded', function (){
    let timeoutId = null;
    const searchInput = document.getElementById('homeSearchInput');
    searchInput.addEventListener('input', function(evt) {
        const query = evt.target.value;
        clearTimeout(timeoutId);

        if (!query.trim()) {
            document.getElementById('result').innerHTML = '';
            return;
        }
        timeoutId = setTimeout(() => {
            _searchHome(query, evt.target);
        }, 500);
    });
    searchInput.addEventListener('focusin', function(evt) {
        if(evt.target.value.trim().length) {
            evt.target.closest('.home-search-box').querySelector('.home-search-result').classList.remove('hidden');
        }
    });
    const popupGuide = document.querySelector('.popup-search-guide');
    document.addEventListener('click', function (evt){
        if(!evt.target.closest('.home-search-box')){
            document.querySelector('.home-search-result').classList.add('hidden');
        }
        if(evt.target.closest('.predictive-search__item--term')){
            const query = evt.target.closest('.home-search-box').querySelector('#homeSearchInput').value.trim();
            window.open(`${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}&resources[type]=product&options[prefix]=last`);
        }
        if(popupGuide && evt.target == popupGuide){
            popupGuide.querySelector('.btn-close').click();
        }
    });
    if(popupGuide) {
        document.querySelector('.guide-info-device').addEventListener('click', function () {
            popupGuide.classList.remove('hidden');
            document.body.classList.add('overflow-hidden');
        });
        popupGuide.querySelector('.btn-close').addEventListener('click', function (evt){
            evt.target.closest('.popup-search-guide').classList.add('hidden');
            document.body.classList.remove('overflow-hidden');
        });
    }
});
function _searchHome(query, inputEl){
    fetch(`${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&section_id=predictive-search`)
        .then(response => response.text())
        .then(data => {
            const searchResultBox = inputEl.closest('.search-box').querySelector('.search-result');
            searchResultBox.classList.remove('hidden');
            searchResultBox.innerHTML = data;
        })
        .catch(error => {
            console.error('Error:', error);
        });
}